import firebase from 'firebase/app'
import 'firebase/firestore'
import config from '../../environmentConfig.json'
const firebaseConfig = {
  apiKey: config[process.env.NODE_ENV].firebaseConfig.apiKey,
  authDomain: config[process.env.NODE_ENV].firebaseConfig.authDomain,
  databaseURL: config[process.env.NODE_ENV].firebaseConfig.databaseURL,
  projectId: config[process.env.NODE_ENV].firebaseConfig.projectId,
  storageBucket: config[process.env.NODE_ENV].firebaseConfig.storageBucket,
  messagingSenderId: config[process.env.NODE_ENV].firebaseConfig.messagingSenderId,
  appId: config[process.env.NODE_ENV].firebaseConfig.appId,
  measurementId: config[process.env.NODE_ENV].firebaseConfig.measurementId,
}
firebase.initializeApp(firebaseConfig)
const db = firebase.firestore()
export { db }
